import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { useAuthedApi, errMsg } from "../../lib/api";
import { BRANDS } from "../../data/india";
import StateCitySelect from "../StateCitySelect";

export default function AdminEditListing({ car, onClose, onSaved }) {
  const api = useAuthedApi();
  const [f, setF] = useState({ brand: car.brand, model: car.model, variant: car.variant || "", year: car.year, price: car.price, km_driven: car.km_driven, state: car.state, city: car.city, status: car.status === "sold" ? "sold" : "active", description: car.description || "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    if (!f.city) return toast.error("Select a city");
    setBusy(true);
    try {
      await api("put", `/admin/listings/${car.id}`, { ...f, year: Number(f.year), price: Number(f.price), km_driven: Number(f.km_driven) });
      toast.success("Listing updated");
      onSaved();
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#111319] border-[#D4AF37]/30 text-white sm:max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="admin-edit-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl gold-text">Edit listing</DialogTitle></DialogHeader>
        <form onSubmit={save} className="grid sm:grid-cols-2 gap-4">
          <div><label className="lux-label">Brand</label><select className="lux-select" value={f.brand} onChange={set("brand")} data-testid="admin-edit-brand">{[...new Set([f.brand, ...BRANDS])].map((b) => <option key={b}>{b}</option>)}</select></div>
          <div><label className="lux-label">Model</label><input className="lux-input" required value={f.model} onChange={set("model")} data-testid="admin-edit-model" /></div>
          <div><label className="lux-label">Variant</label><input className="lux-input" value={f.variant} onChange={set("variant")} data-testid="admin-edit-variant" /></div>
          <div><label className="lux-label">Year</label><input className="lux-input" type="number" required value={f.year} onChange={set("year")} data-testid="admin-edit-year" /></div>
          <div><label className="lux-label">Price (₹)</label><input className="lux-input" type="number" required min="1" value={f.price} onChange={set("price")} data-testid="admin-edit-price" /></div>
          <div><label className="lux-label">KM driven</label><input className="lux-input" type="number" required min="0" value={f.km_driven} onChange={set("km_driven")} data-testid="admin-edit-km" /></div>
          <StateCitySelect state={f.state} city={f.city} prefix="admin-edit-" onChange={(v) => setF({ ...f, ...v })} />
          <div><label className="lux-label">Status</label><select className="lux-select" value={f.status} onChange={set("status")} data-testid="admin-edit-status"><option value="active">Active</option><option value="sold">Sold</option></select></div>
          <div className="sm:col-span-2"><label className="lux-label">Description</label><textarea className="lux-textarea" rows={3} value={f.description} onChange={set("description")} data-testid="admin-edit-description" /></div>
          <div className="sm:col-span-2 flex gap-3 justify-end">
            <button type="button" className="btn-outline" onClick={onClose}>Cancel</button>
            <button className="btn-gold" disabled={busy} data-testid="admin-edit-save">{busy ? "Saving..." : "Save changes"}</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
